export const getFromLocaleStorage = (key: TLocalStorageKeys) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.log('saveToLocaleStorage error', e);

    return undefined;
  }
};
